import { useIntl } from 'react-intl'
import useBedbankPackageViews from 'hooks/useBedbankPackageViews'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BedbankMobileStickyHeaderFilters from '../BedbankMobileStickyHeaderFilters'
import BedbankRoomOptionsMobile from '../BedbankRoomOptionsMobile'

interface Props {
  offer: App.BedbankOffer
  selectedBedbankRoomId: string
  onClose: () => void
  onBack?: () => void
}

function BedbankPackageSelectionModal(props: Props) {
  const intl = useIntl()
  const {
    selectedBedbankRoomId,
    offer,
    onClose,
    onBack,
  } = props

  const [packageViews, fetchingRates] = useBedbankPackageViews(offer)

  return (
    <>
      <ModalHeader
        title={intl.formatMessage({
          id: '1WduQIs3Bfzrt_1Ef8kG',
          defaultMessage: 'Select a package',
          description: 'Title for bedbank package selection modal dialog window',
        })}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <BedbankMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <BedbankRoomOptionsMobile
          packageViews={packageViews}
          fetchingRates={fetchingRates}
          offer={offer}
          topPackageId={selectedBedbankRoomId}
        />
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState) => ({
  selectedBedbankRoomId: state.selectedBedbankRoomId,
  offer: state.bedbankOffer!,
}), BedbankPackageSelectionModal)
